import { MessageBarType } from "@fluentui/react";

// Iterates over the passed enum are return a list of keys.
export const enumIterator = (collection: any) => {
  return Object.keys(collection).filter((key) => !isNaN(Number(collection[key])));
};

export const maxImageSizeInBytes = 2097152;

// List of the names of various modal states
export enum ModalType {
  LOAD_REGION_FAILURE = "LOAD_REGION_FAILURE",
  LOAD_REGION_LIST_FAILURE = "LOAD_REGION_LIST_FAILURE",
  LOAD_CAFE_LIST_FAILURE = "LOAD_CAFE_LIST_FAILURE",
  LOAD_CAFE_FAILURE = "LOAD_CAFE_FAILURE",
  LOAD_STATION_LIST_FAILURE = "LOAD_STATION_LIST_FAILURE",
  LOAD_STATION_FAILURE = "LOAD_STATION_FAILURE",
  ADD_STATION_FAILURE = "ADD_STATION_FAILURE",
  LOAD_MENU_FAILURE = "LOAD_MENU_FAILURE",
  LOAD_CAFE_ALLERGEN_BANK_FAILURE = "LOAD_CAFE_ALLERGEN_BANK_FAILURE",
  NO_MENU_SELECTED = "NO_MENU_SELECTED",
  SAVE_MENU_FAILURE = "SAVE_MENU_FAILURE",
  ADD_CAFE_FAILURE = "ADD_CAFE_FAILURE",
  UPDATE_CAFE_FAILURE = "UPDATE_CAFE_FAILURE",
  UPDATE_CAFE_SUCCESS = "UPDATE_CAFE_SUCCESS",
  ADD_ITEM_NO_DAYS_SELECTED = "ADD_ITEM_NO_DAYS_SELECTED",
  CONFIRM_DELETE_STATION = "CONFIRM_DELETE_STATION",
  DELETE_STATION_FAILURE = "DELETE_STATION_FAILURE",
  DELETE_MENU_ITEM_FAILURE = "DELETE_MENU_ITEM_FAILURE",
  IMAGE_UPLOAD_FAILURE = "IMAGE_UPLOAD_FAILURE",
  IMAGE_DELETE_FAILURE = "IMAGE_DELETE_FAILURE",
  ADD_ITEM_TO_BANK_FAILURE = "ADD_ITEM_TO_BANK_FAILURE",
  LOAD_STATION_ITEM_BANK_FAILURE = "LOAD_STATION_ITEM_BANK_FAILURE",
  CONFIRM_MENU_ITEM_DELETE = "CONFIRM_MENU_ITEM_DELETE",
  CONFIRM_PUBLISH_MENU = "CONFIRM_PUBLISH_MENU",
  CONFIRM_DELETE_MENU = "CONFIRM_DELETE_MENU",
  DELETE_MENU_FAILURE = "DELETE_MENU_FAILURE",
  PUBLISH_MENU_FAILURE = "PUBLISH_MENU_FAILURE",
  UPDATE_DRAFT_MENU_FAILURE = "UPDATE_DRAFT_MENU_FAILURE",
  DELETE_IMAGE_FAILURE = "DELETE_IMAGE_FAILURE",
}

// List of modals with their title strings.
export enum ModalTitle {
  LOAD_REGION_FAILURE = "We couldn't load the selected region",
  LOAD_REGION_LIST_FAILURE = "We couldn't load regions",
  LOAD_CAFE_LIST_FAILURE = "We couldn't load the cafe",
  LOAD_CAFE_FAILURE = "No cafes were found",
  LOAD_STATION_LIST_FAILURE = "Something went wrong",
  LOAD_STATION_FAILURE = "No stations were found",
  LOAD_STATION_ITEM_BANK_FAILURE = "We couldn't load the menu item bank for this station",
  ADD_STATION_FAILURE = "Something went wrong",
  LOAD_MENU_FAILURE = "We couldn't load the menu",
  LOAD_CAFE_ALLERGEN_BANK_FAILURE = "We couldn't load allergen suggestions",
  NO_MENU_SELECTED = "No menu has been selected",
  SAVE_MENU_FAILURE = "Something went wrong",
  ADD_CAFE_FAILURE = "We couldn't add the cafe",
  UPDATE_CAFE_FAILURE = "We couldn't update the cafe",
  UPDATE_CAFE_SUCCESS = "Cafe successfully updated",
  ADD_ITEM_NO_DAYS_SELECTED = "No day of the week chosen",
  CONFIRM_DELETE_STATION = "Confirm station delete",
  DELETE_STATION_FAILURE = "Something went wrong",
  DELETE_MENU_ITEM_FAILURE = "Something went wrong",
  IMAGE_UPLOAD_FAILURE = "Image upload failed",
  IMAGE_DELETE_FAILURE = "Image deletion failed",
  ADD_ITEM_TO_BANK_FAILURE = "Modify item failure",
  CONFIRM_MENU_ITEM_DELETE = "Delete menu item?",
  CONFIRM_PUBLISH_MENU = "Publish the menu?",
  CONFIRM_DELETE_MENU = "Delete the menu?",
  DELETE_MENU_FAILURE = "Menu deletion failed",
  PUBLISH_MENU_FAILURE = "Failed to publish the menu",
  UPDATE_DRAFT_MENU_FAILURE = "Failed to update the draft menu",
  DELETE_IMAGE_FAILURE = "Failed to delete the selected image",
}

// List of modals with their modal body strings.
export enum ModalText {
  LOAD_REGION_FAILURE = "Something went wrong and we couldn't load your selection. Please try again.",
  LOAD_REGION_LIST_FAILURE = "Something went wrong and we couldn't load your selection. Please try again.",
  LOAD_CAFE_LIST_FAILURE = "Something went wrong and we couldn't load your selection. Please try again.",
  LOAD_CAFE_FAILURE = "We couldn't find the cafe you were looking for in this region. Please try again.",
  LOAD_STATION_LIST_FAILURE = "We couldn't load any stations for this cafe. Please refresh and try again. If this cafe has no stations, create your menu at the cafe level instead.",
  LOAD_STATION_FAILURE = "We couldn't find any stations for this cafe. If this cafe has no stations, create your menu at the cafe level instead.",
  ADD_STATION_FAILURE = "We couldn't add the station to this cafe. Please try again. Sorry for the inconvenience.",
  LOAD_STATION_ITEM_BANK_FAILURE = "Please refresh the page and try again",
  LOAD_MENU_FAILURE = "Something went wrong and we couldn't load your menu. Please refresh and try again.",
  LOAD_CAFE_ALLERGEN_BANK_FAILURE = "If you want to see allergen suggestions, please refresh and try again.",
  NO_MENU_SELECTED = "Please choose the menu you wish to work on.",
  SAVE_MENU_FAILURE = "We couldn't save the menu. Please try again.",
  ADD_CAFE_FAILURE = "Something went wrong and we couldn't add your cafe. Please try again.",
  UPDATE_CAFE_FAILURE = "Something went wrong and we couldn't update your cafe. Please try again.",
  UPDATE_CAFE_SUCCESS = "Your changes have been saved and the cafe has been updated to reflect them.",
  ADD_ITEM_NO_DAYS_SELECTED = "Please select which day or days of the week your menu item will be served.",
  CONFIRM_DELETE_STATION = "Deleting the station will remove all associated menus and menu items, as well.",
  DELETE_STATION_FAILURE = "We couldn't delete the station from this cafe. Please try again. Sorry for the inconvenience.",
  DELETE_MENU_ITEM_FAILURE = "We couldn't delete the menu item from this station. Please try again. Sorry for the inconvenience",
  IMAGE_UPLOAD_FAILURE = "It may be because the file size is too large, or an unknown server error. If the file size exceeds 2MB, try to reduce it. If the file doesn’t exceed 2MB, refresh the page and try again.",
  IMAGE_DELETE_FAILURE = "Something went wrong and we couldn't delete this image. Please try again later.",
  ADD_ITEM_TO_BANK_FAILURE = "We were unable to add the item to the station's item bank. Please reload the page and try again.",
  CONFIRM_MENU_ITEM_DELETE = "Are you sure you want to delete the menu item selected?",
  CONFIRM_PUBLISH_MENU = "Are you ready to publish your menu? Once you do, you'll still be able to update here, but will have to republish it.",
  CONFIRM_DELETE_MENU = "Are you sure you want to delete the existing menu? The menu preview will revert to the currently published menu, if available.",
  DELETE_MENU_FAILURE = "Something went wrong and we couldn't delete the existing menu. Try unselecting all your menu items and updating the menu instead.",
  PUBLISH_MENU_FAILURE = "Something went wrong and we were unable to publish the menu.",
  UPDATE_DRAFT_MENU_FAILURE = "Something went wrong, and your update was not saved to the draft. Try refreshing the page and making the change again.",
  DELETE_IMAGE_FAILURE = "Something went wrong when trying to delete this item's image. Changes have not been saved.",
}

// List of modals with their prefered 'submit' button text.
export enum ModalSubmitText {
  CONFIRM_DELETE_STATION = "Confirm",
  CONFIRM_PUBLISH_MENU = "Publish menu",
  CONFIRM_DELETE_MENU = "Delete menu",
  CONFIRM_MENU_ITEM_DELETE = "Delete",
}

// List of values for the Menu Preview message bar component.
export enum MenuPublishedState {
  UNPUBLISHED_CHANGES = "UNPUBLISHED_CHANGES",
  PUBLISHING_IN_PROGRESS = "PUBLISHING_IN_PROGRESS",
  CHANGES_PUBLISHED_SUCCESSFULLY = "CHANGES_PUBLISHED_SUCCESSFULLY",
  MENU_DELETED = "MENU_DELETED",
  DELETING_IN_PROGRESS = "DELETING_IN_PROGRESS",
  ITEM_ADDED_TO_BANK_SUCCESSFULLY = "Item added to menu bank successfully",
  ITEM_EDITED_IN_BANK_SUCCESSFULLY = "Item edited in menu bank successfully",
  ITEM_REMOVE_FROM_BANK_SUCCESSFULLY = "Item removed from menu bank successfully",
  ITEM_SAVED_TO_MENU_SUCCESSFULLY = "Item added to menu successfully",
  LOADING = "loading...",
}

// List of corresponding MessageBarTypes
export enum MessageBarKind {
  UNPUBLISHED_CHANGES = MessageBarType.warning,
  PUBLISHING_IN_PROGRESS = MessageBarType.info,
  CHANGES_PUBLISHED_SUCCESSFULLY = MessageBarType.success,
  MENU_DELETED = MessageBarType.success,
  DELETING_IN_PROGRESS = MessageBarType.info,
  ITEM_ADDED_TO_BANK_SUCCESSFULLY = MessageBarType.success,
  ITEM_REMOVE_FROM_BANK_SUCCESSFULLY = MessageBarType.success,
  LOADING = MessageBarType.info,
  STATION_CREATED_SUCCESSFULLY = MessageBarType.success,
  STATION_DELETED_SUCCESSFULLY = MessageBarType.success,
  ITEM_SAVED_TO_MENU_SUCCESSFULLY = MessageBarType.success,
  ITEM_EDITED_IN_BANK_SUCCESSFULLY = MessageBarType.success,
}

export enum MessageBarText {
  UNPUBLISHED_CHANGES = "Menu has not been published",
  PUBLISHING_IN_PROGRESS = "Publishing",
  CHANGES_PUBLISHED_SUCCESSFULLY = "Menu successfully published",
  MENU_DELETED = "Unsaved changes deleted successfully",
  DELETING_IN_PROGRESS = "Deleting unsaved changes",
  ITEM_ADDED_TO_BANK_SUCCESSFULLY = "Item added to menu bank successfully",
  ITEM_REMOVE_FROM_BANK_SUCCESSFULLY = "Item removed from menu bank successfully",
  LOADING = "loading...",
  STATION_CREATED_SUCCESSFULLY = "Station created successfully",
  STATION_DELETED_SUCCESSFULLY = "Station deleted successfully",
}

// List of values for the Menu Preview message bar component.
export enum StationEditState {
  STATION_CREATED_SUCCESSFULLY = "station created successfully",
  STATION_DELETED_SUCCESSFULLY = "station deleted successfully",
}

// Valid open / close times. Used for UpdateCafe time inputs.

export const validTimes = [
  "00:00",
  "00:15",
  "00:30",
  "00:45",
  "01:00",
  "01:15",
  "01:30",
  "01:45",
  "02:00",
  "02:15",
  "02:30",
  "02:45",
  "03:00",
  "03:15",
  "03:30",
  "03:45",
  "04:00",
  "04:15",
  "04:30",
  "04:45",
  "05:00",
  "05:15",
  "05:30",
  "05:45",
  "06:00",
  "06:15",
  "06:30",
  "06:45",
  "07:00",
  "07:15",
  "07:30",
  "07:45",
  "08:00",
  "08:15",
  "08:30",
  "08:45",
  "09:00",
  "09:15",
  "09:30",
  "09:45",
  "10:00",
  "10:15",
  "10:30",
  "10:45",
  "11:00",
  "11:15",
  "11:30",
  "11:45",
  "12:00",
  "12:15",
  "12:30",
  "12:45",
  "13:00",
  "13:15",
  "13:30",
  "13:45",
  "14:00",
  "14:15",
  "14:30",
  "14:45",
  "15:00",
  "15:15",
  "15:30",
  "15:45",
  "16:00",
  "16:15",
  "16:30",
  "16:45",
  "17:00",
  "17:15",
  "17:30",
  "17:45",
  "18:00",
  "18:15",
  "18:30",
  "18:45",
  "19:00",
  "19:15",
  "19:30",
  "19:45",
  "20:00",
  "20:15",
  "20:30",
  "20:45",
  "21:00",
  "21:15",
  "21:30",
  "21:45",
  "22:00",
  "22:15",
  "22:30",
  "22:45",
  "23:00",
  "23:15",
  "23:30",
  "23:45",
];

// List of name for default Constants
export enum DefaultConstant {
  MICROSOFT = "Microsoft",
  AGILYSYS = "Agilysys",
}

export enum syncCafeStatus {
  ERROR = "Error",
  SUCCESS = "Success",
  IDLE = "Idle",
  PROGRESS = "Progress",
  NOTAUTHORIZED = "UserNotAuthorizedToSyncCafes",
}
export const delayInMilliseconds = 1500;

export const BlocklistedCharacterSetForName = ["/", "\\"];
